module.exports = __webpack_public_path__ + "static/media/icon-right-purple.1b7ab7cf.svg";